

























import { defineComponent } from '@vue/composition-api';
import ALink from '../a-link/a-link.vue';
import { trackEvent } from './../../../utils/index';

const name = 'ttam-tooltip-info';

export default defineComponent({
  name,
  components: {
    ALink,
  },
  props: {
    tips: {
      type: String,
      default: '',
    },
    linkText: {
      type: String,
      default: '',
    },
    linkHref: {
      type: String,
      default: '',
    },
    placement: {
      type: String,
      default: 'top',
    },
    contentShowKey: {
      // hover弹窗内容展现埋点
      type: String,
      default: '',
    },
    exposeKey: {
      // tooltip hover曝光埋点
      type: String,
      default: '',
    },
    linkClickKey: {
      // 超链接点击埋点事件
      type: String,
      default: '',
    },
  },
  setup(props) {
    const handleTrackEvent = () => {
      if (props.linkClickKey) {
        trackEvent(props.linkClickKey as string);
      }
    };

    return { name, handleTrackEvent };
  },
});
